import { Component } from "react";
import { connect } from "react-redux";
import { RingProgress } from "@ant-design/charts";
import { Button, Card, Col, message, Modal, Row, Spin, DatePicker } from "antd";
import moment from "moment";
import "../Common.global.css";

const flexColumnOverflow = {
  display: "flex",
  flex: "auto",
  flexDirection: "column",
  overflowY: "scroll",
};

const flexColumn = {
  display: "flex",
  flex: "auto",
  flexDirection: "column",
};

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      dataType: "today",
      filterDate: moment(new Date()),
      insideData: {},
    };
  }

  componentDidMount() {
    const { filterDate } = this.state;
    this.refreshOverview(filterDate);
  }

  onExportClick = () => {
    const { accessToken } = this.props;
    const { filterDate } = this.state;

    this.setState({
      isLoading: true,
    });
    fetch("/api/v1/dashboard/overview/download/pdf", {
      method: "POST",
      headers: {
        "Content-type": "application/json",
        token: accessToken,
      },
      body: JSON.stringify({
        filterDate,
      }),
    })
      .then((res) => {
        if (!res.ok) throw new Error(res.statusText);
        return res.blob();
      })
      .then((blob) => {
        const filename = moment(new Date()).format("YYYYMMDDHHmmss");
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${filename}_InsideBuildingReport.pdf`;
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove(); //afterwards we remove the element again
        message.success("Inside Building Report Exported Successfully!");
      })
      .catch((err) => {
        message.error(
          err instanceof Error ? err.message : "Server cannot be reached"
        );
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  refreshOverview = (filterDate) => {
    const { accessToken } = this.props;

    this.setState({
      isLoading: true,
      insideData: {},
    });
    fetch(`/api/v1/dashboard/overview`, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
        token: accessToken,
      },
      body: JSON.stringify({
        filterDate,
      }),
    })
      .then((res) => {
        if (!res.ok) {
          return res
            .json()
            .catch(() => {
              // Couldn't parse the JSON
              throw new Error(res.statusText);
            })
            .then(({ error }) => {
              // Got valid JSON with error response, use it
              throw new Error(error || res.statusText);
            });
        }
        return res.json();
      })
      .then(({ insideData }) => {
        this.setState({
          insideData,
        });
      })
      .catch((err) => {
        message.error(
          err instanceof Error ? err.message : "Server cannot be reached"
        );
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  onRadioChange = ({ target: { value } }) => {
    this.setState({
      dataType: value,
    });
  };

  render() {
    const { filterDate, isLoading, insideData } = this.state;
    return (
      <div className="site-feature-container">
        <div className="page-header-container">
          <div>
            <div className="page-header-main">Dashboard </div>
            <div className="page-header-sub">Overview</div>
          </div>
        </div>
        <Card bodyStyle={flexColumn} style={flexColumnOverflow}>
          <Spin tip="Please Wait..." spinning={isLoading}>
            <Row>
              <Col xl={16} lg={24} sm={24} xs={24} style={{ marginBottom: 24 }}>
                <Card title="Inside Parking Lot">
                  <Row style={{ padding: "20px 0" }}>
                    <Col span={8}>
                      <div
                        style={{
                          textAlign: "center",
                          paddingBottom: "5px",
                          fontWeight: "bold",
                        }}
                      >
                        Car
                      </div>
                      <RingProgress
                        forceFit
                        height={128}
                        percent={
                          ((insideData &&
                            insideData["SISB-PU"] &&
                            insideData["SISB-PU"]["STUDENT"]) ||
                            0) /
                          ((insideData &&
                            insideData["SISB-PU"] &&
                            insideData["SISB-PU"]["STUDENT_TOTAL"]) ||
                            0)
                        }
                      />
                      <div style={{ textAlign: "center", paddingTop: "5px" }}>
                        {`${
                          (insideData &&
                            insideData["SISB-PU"] &&
                            insideData["SISB-PU"]["STUDENT"]) ||
                          0
                        } / ${
                          (insideData &&
                            insideData["SISB-PU"] &&
                            insideData["SISB-PU"]["STUDENT_TOTAL"]) ||
                          0
                        }`}
                      </div>
                    </Col>
                    <Col span={8}>
                      <div
                        style={{
                          textAlign: "center",
                          paddingBottom: "5px",
                          fontWeight: "bold",
                        }}
                      >
                        Moto
                      </div>
                      <RingProgress
                        color="#5DDECF"
                        forceFit
                        height={128}
                        percent={
                          ((insideData &&
                            insideData["SISB-PU"] &&
                            insideData["SISB-PU"]["STAFF"]) ||
                            0) /
                          ((insideData &&
                            insideData["SISB-PU"] &&
                            insideData["SISB-PU"]["STAFF_TOTAL"]) ||
                            0)
                        }
                      />
                      <div style={{ textAlign: "center", paddingTop: "5px" }}>
                        {`${
                          (insideData &&
                            insideData["SISB-PU"] &&
                            insideData["SISB-PU"]["STAFF"]) ||
                          0
                        } / ${
                          (insideData &&
                            insideData["SISB-PU"] &&
                            insideData["SISB-PU"]["STAFF_TOTAL"]) ||
                          0
                        }`}
                      </div>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
            <Row></Row>
          </Spin>
        </Card>
      </div>
    );
  }
}

function mapStateToProps({ auth }) {
  return {
    accessToken: auth.token.accessToken,
  };
}

export default connect(mapStateToProps, null)(Dashboard);
